export default "__VITE_ASSET__CfEG0p_1__"